import { render, staticRenderFns } from "./STBConfig.vue?vue&type=template&id=34993f59&"
import script from "./STBConfig.vue?vue&type=script&lang=js&"
export * from "./STBConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports